import {
  coreApi_default
} from "./chunk-NB6PR3JZ.mjs";

// src/adapters/settings.ts
var getRollbackWithdrawalSettings = async () => {
  try {
    const { data } = await coreApi_default.get("/settings");
    const { withdrawal_rollback } = data.data;
    return withdrawal_rollback;
  } catch {
    return false;
  }
};

export {
  getRollbackWithdrawalSettings
};
